export default "__VITE_ASSET__BcTjxTMF__"